import React, { useMemo, useState, useRef  ,useEffect, useReducer, fetchData} from 'react';
import { Alert, Button, Container, Card, Table, Modal, Accordion,Form, FormLabel, Col, Row } from 'react-bootstrap';

import {Sida,Rubrik,ContentWrapper,Stycke,StyckeCompact} from "../ContentStyles";
import useBackend, {XLogOff, IsLoggedIn, Loading, SpinnerX, CallDownload} from '../../services/useBackend';
import MaterialReactTable from 'material-react-table';
import {getOptions} from '../../services/misc';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { FaFilePdf, FaReceipt, FaEnvelope,FaBars, FaUser, FaFileDownload, FaDownload } from 'react-icons/fa';
//import { mkConfig, generateCsv, download } from 'export-to-csv';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import download from 'downloadjs'
import { Link } from 'react-router-dom';

import { Branding, Helmetx } from '../../services/misc';

function SellChart() {

  const {loading, data, Refresh, Seek} =  useBackend('/api/reports/sellchart');
  
  var today = new Date(Date.now());
  var firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const [startDate, setStartDate] = useState(firstDayOfMonth.toLocaleDateString());
  
  var lastDayOfMonth = new Date(today.getFullYear(), today.getMonth()+1, 0);
  const [endDate, setEndDate] = useState(lastDayOfMonth.toLocaleDateString());

  const [hideResult, setHideResult] = useState(false);
  
  const [shopFilter, setShopFilter] = useState(0);

  const [groupFilter, setGroupFilter] = useState(0);

  const columns = useMemo(() => [
    { size: 20, accessorKey: 'Name',   header: 'Namn' },                        
    { size: 10, accessorKey: 'Qty',  header: 'Antal' },                 

        {
            size: 20, header: 'Amount', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ row }) => (<>{row.original.Amount.toFixed(2)}</>),
        },
  ]);

  async function handleExportData(SoldProducts) {        
    const csv = await CallDownload("/api/reports/sell?startdate="+startDate+"&enddate="+endDate+"&ShopId=0&Format=xls");
    console.log("........");
    console.log(csv);
    //download(csv);
    download(csv, "report.csv", 'text/csv')
  };  

  useEffect(() => {
    if (startDate=="" || endDate=="" ) { setHideResult(true);} else {setHideResult(false);}
    if (Date.parse(endDate)<Date.parse(startDate) ) { setHideResult(true);}

     Seek("?startdate="+startDate+"&enddate="+endDate+"&ShopId="+shopFilter+"&GroupId="+groupFilter);
  }, [startDate, endDate, shopFilter, groupFilter]);

  const data2 = [
  { Date: 'Jan', Cnt: 4000, Amount: 2400 },
  { Date: 'Feb', Cnt: 3000, Amount: 1398 },
  { Date: 'Mar', Cnt: 2000, Amount: 9800 },
  { Date: 'Apr', Cnt: 2780, Amount: 3908 },
  { Date: 'Maj', Cnt: 1890, Amount: 4800 },
  { Date: 'Jun', Cnt: 2390, Amount: 3800 },
];

  return (
        <ContentWrapper>
        <Container>
            <Sida>
                <Rubrik>Försäljningsutveckling</Rubrik>

                <div className='d-flex'></div>

                <Row>
                    <Col>Startdatum</Col>
                    <Col>Slutdatum</Col>
                    <Col>Produktgrupp</Col>
                    <Col>Butik</Col>

                </Row>

                <Row>
                    <Col><Form.Control type="date" name="Name" placeholder="Startdatum" value={startDate} onChange={async (e) => {await setStartDate(e.target.value); }} /></Col>
                    <Col><Form.Control type="date" name="Name_" placeholder="Slutdatum" value={endDate}   onChange={async (e) => {setEndDate(e.target.value); }} /></Col>

                    <Col>
                        <Form.Select name="GroupId" m onChange={async (e) => {setGroupFilter(e.target.value); }} >
                            <option key="0" value="0">Alla</option>                                           
                            {!loading && getOptions(data.ProductGroups)}
                        </Form.Select>                    
                    </Col>

                    <Col>
                        <Form.Select name="ShopId" m onChange={async (e) => {setShopFilter(e.target.value); }} >
                            <option key="0" value="0">Alla</option>                                           
                            {!loading && getOptions(data.Shops)}
                        </Form.Select>                    
                    </Col>
                    {/* <Col><Button variant='secondary' onClick={() => {Seek("?startdate="+startDate+"&enddate="+endDate+"&ShopId="+shopFilter)}}>Sök/Uppdatera</Button> </Col> */}
                </Row>

                {loading && <SpinnerX />}

                {hideResult && <><br></br><Alert variant="danger">OBS ovanstående datumkombination är ogiltlig!</Alert> </>}

                {!loading &&
                    (      
                    <>              
                        <br></br>


    <div style={{ width: '100%', height: 600 }}>
      <ResponsiveContainer>
                        <LineChart responsive data={data.sellchart2} margin={{ top: 5, right: 30, left: 20, bottom: 70 }}>
                        {/* Rutnät i bakgrunden */}
                        <CartesianGrid strokeDasharray="3 3" />
                        
                        {/* Axlar */}
                        <XAxis dataKey="Date" angle={90} textAnchor="start" tick_={false}>
                            </XAxis>
                        <YAxis  />
                        
                        {/* Hover-effekt och förklaring */}
                        <Tooltip />
                        <Legend />
                        
                        {/* Linjerna som ritas ut */}
                        {/* <Line type="monotone" dataKey="Cnt" stroke="#8884d8" activeDot={{ r: 8 }} /> */}
                        <Line type="monotone" dataKey="Amount" stroke={Branding().ButtonColor}  />
                        </LineChart>
                              </ResponsiveContainer>
    </div>

                                                           
                    </>                                          
                        
                    )
                }
               
            </Sida>
        </Container>
    </ContentWrapper>        
  );
}

export default SellChart;